/*
 * @Author: Teemo Ding
 * @Date: 2021-10-08 15:15:14
 * @LastEditTime: 2021-10-08 16:29:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Input/DebounceInput.tsx
 */
import { useCreation, useDebounceFn } from 'ahooks';
import { Input } from 'antd';
import React, { useState } from 'react';

export const DebounceInput = ({ value, onChange, ...props }: any) => {
  const initValue = useCreation(() => value, []);
  const [_value, _setValue] = useState(value);
  const { run } = useDebounceFn(
    () => {
      onChange(_value);
    },
    {
      wait: 1000,
    },
  );
  const resetInputValue = () => {
    if (!_value.trim()) {
      onChange(initValue);
      _setValue(initValue);
    }
  };

  React.useEffect(() => {
    _setValue(value);
  }, [value]);

  return (
    <Input
      {...props}
      value={_value}
      onBlur={resetInputValue}
      onChange={(e) => {
        _setValue(e.target.value);
        run();
      }}
    />
  );
};
